import React from 'react'
import InstructorNavbar from '../components/instructor/InstructorNavbar'
import QuizInstructorList from '../components/quiz/QuizInstructorList'

const InstructorQuizListPage = () => {
  return (
    <>
    <InstructorNavbar/>
    <QuizInstructorList/>
    </>
  )
}

export default InstructorQuizListPage